var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwishLogoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.13 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Namnl\xF6s_\xF6vertoning_63);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Namnl\xF6s_\xF6vertoning_91);\n      }\n\n      .cls-3 {\n        fill: url(#Namnl\xF6s_\xF6vertoning_76);\n      }\n\n      .cls-4 {\n        fill: url(#Namnl\xF6s_\xF6vertoning_40);\n      }\n\n      .cls-5 {\n        fill: #4a4a49;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_76",
    "data-name": "Namnl\\xF6s \\xF6vertoning 76",
    x1: -381.89,
    y1: 347.59,
    x2: -381.93,
    y2: 347.68,
    gradientTransform: "translate(114714.35 128828.87) scale(300.26 -370.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_91",
    "data-name": "Namnl\\xF6s \\xF6vertoning 91",
    x1: -381.75,
    y1: 347.76,
    x2: -381.83,
    y2: 347.59,
    gradientTransform: "translate(104595.91 104410.35) scale(273.83 -300.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ef7d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#b82585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213a8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_40",
    "data-name": "Namnl\\xF6s \\xF6vertoning 40",
    x1: -381.57,
    y1: 347.56,
    x2: -381.54,
    y2: 347.47,
    gradientTransform: "translate(114594.88 128779.8) scale(300.25 -370.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8acbc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5fc4e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7295cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213a8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_63",
    "data-name": "Namnl\\xF6s \\xF6vertoning 63",
    x1: -381.59,
    y1: 347.3,
    x2: -381.5,
    y2: 347.47,
    gradientTransform: "translate(104502.9 104290.82) scale(273.83 -300.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0056a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#29b8ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#74b959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd500"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.35,85.84c0-.36.07-.69.2-1.01.13-.31.31-.59.54-.82.23-.23.49-.42.8-.55.3-.13.63-.2.98-.2s.69.07.99.2c.31.13.58.32.81.55s.41.51.54.82c.13.31.2.65.2,1.01s-.07.69-.2,1.01c-.13.31-.31.59-.54.82-.23.23-.5.42-.81.55-.31.13-.64.2-.99.2s-.68-.07-.98-.2c-.3-.13-.57-.32-.8-.55-.23-.23-.41-.51-.54-.82-.13-.31-.2-.65-.2-1.01ZM67.87,85.84c0,.3.05.57.15.83.1.25.24.48.42.66.18.19.39.34.63.45.24.11.51.16.79.16s.55-.05.8-.16c.25-.11.46-.26.64-.45s.32-.41.43-.66c.1-.25.16-.53.16-.83s-.05-.57-.16-.83c-.1-.25-.25-.48-.43-.66-.18-.19-.4-.34-.64-.45-.25-.11-.51-.16-.8-.16s-.55.05-.79.16c-.24.11-.45.26-.63.45-.18.19-.32.41-.42.66-.1.25-.15.53-.15.83ZM69,84.73c0-.16.08-.23.23-.23h.8c.25,0,.46.07.61.22.15.15.23.34.23.59,0,.1-.02.2-.05.28-.03.08-.07.15-.12.21-.05.06-.1.11-.16.14s-.11.06-.17.08h0s.01.03.02.04c0,0,.02.02.03.05,0,.02.02.05.04.07l.37.71c.04.08.05.14.03.19-.02.05-.08.07-.16.07h-.08c-.13,0-.22-.06-.28-.17l-.41-.86h-.44v.81c0,.15-.07.23-.22.23h-.06c-.15,0-.22-.08-.22-.23v-2.2ZM69.93,85.77c.14,0,.24-.04.32-.12s.11-.19.11-.33-.04-.24-.11-.32c-.08-.08-.18-.11-.31-.11h-.43v.88h.42ZM49.3,87.46c.8,0,1.48.1,2.03.31.56.2.99.39,1.31.56.27.14.42.33.47.56.05.23,0,.49-.12.75l-.24.42c-.14.28-.32.45-.54.49s-.48,0-.78-.12c-.27-.13-.59-.25-.96-.39s-.82-.2-1.32-.2-.92.1-1.2.31c-.28.2-.42.49-.42.87,0,.33.15.6.44.8.29.2.66.38,1.11.54.45.16.93.32,1.44.51.51.18.99.41,1.44.69s.82.64,1.11,1.08c.29.44.44.99.44,1.67,0,.53-.11,1.02-.32,1.47s-.52.83-.92,1.16c-.4.33-.88.59-1.45.78-.56.19-1.19.28-1.88.28-.97,0-1.79-.14-2.46-.42-.67-.28-1.18-.55-1.54-.8-.27-.16-.42-.35-.45-.59-.03-.23.04-.49.21-.75l.28-.42c.17-.25.36-.39.58-.42s.47.03.76.19c.28.16.65.33,1.09.53.45.2.98.29,1.59.29.52,0,.93-.11,1.22-.33s.45-.52.45-.89c0-.33-.15-.59-.44-.79-.29-.2-.66-.38-1.11-.54-.45-.16-.93-.34-1.44-.53-.51-.19-.99-.42-1.44-.7-.45-.28-.82-.64-1.11-1.08-.29-.44-.44-1-.44-1.69,0-.58.12-1.1.36-1.55.24-.45.57-.83.99-1.13s.9-.52,1.46-.68c.56-.16,1.15-.23,1.78-.23ZM14.33,87.46c.8,0,1.48.1,2.03.31s.99.39,1.31.56c.27.14.42.33.47.56.05.23,0,.49-.12.75l-.24.42c-.14.28-.32.45-.54.49s-.48,0-.78-.12c-.27-.13-.59-.25-.96-.39-.38-.13-.82-.2-1.32-.2s-.92.1-1.2.31c-.28.2-.42.49-.42.87,0,.33.15.6.44.8.29.2.66.38,1.11.54.45.16.93.32,1.44.51.51.18.99.41,1.44.69.45.28.82.64,1.11,1.08.29.44.44.99.44,1.67,0,.53-.11,1.02-.32,1.47s-.52.83-.92,1.16c-.4.33-.88.59-1.45.78-.56.19-1.19.28-1.88.28-.97,0-1.79-.14-2.46-.42-.67-.28-1.18-.55-1.54-.8-.27-.16-.42-.35-.45-.59-.03-.23.04-.49.21-.75l.28-.42c.17-.25.36-.39.58-.42.21-.03.47.03.76.19.28.16.65.33,1.09.53.45.2.98.29,1.59.29.52,0,.93-.11,1.22-.33.3-.22.45-.52.45-.89,0-.33-.15-.59-.44-.79-.29-.2-.66-.38-1.11-.54-.45-.16-.93-.34-1.44-.53-.51-.19-.99-.42-1.44-.7-.45-.28-.82-.64-1.11-1.08s-.44-1-.44-1.69c0-.58.12-1.1.36-1.55.24-.45.57-.83.99-1.13s.9-.52,1.46-.68c.56-.16,1.15-.23,1.78-.23ZM57.23,83.04c.66,0,.99.33.99.99v4.84c0,.16,0,.29-.01.41,0,.12-.02.22-.04.32-.02.11-.02.2-.02.28h.05c.14-.28.34-.57.6-.86.26-.29.56-.55.92-.79.35-.23.75-.42,1.2-.56.45-.14.93-.21,1.45-.21,1.33,0,2.36.36,3.09,1.08.73.72,1.09,1.88,1.09,3.48v6.72c0,.66-.33.99-.99.99h-1.01c-.66,0-.99-.33-.99-.99v-6.11c0-.74-.13-1.33-.38-1.77s-.75-.67-1.51-.67c-.52,0-.99.1-1.42.31-.43.2-.8.48-1.09.83-.3.35-.53.77-.69,1.26-.16.49-.25,1.01-.25,1.57v4.58c0,.66-.33.99-.99.99h-1.01c-.66,0-.99-.33-.99-.99v-14.71c0-.66.33-.99.99-.99h1.01ZM41.6,87.74c.64,0,.96.33.96.99v10.01c0,.66-.32.99-.96.99h-1.04c-.64,0-.96-.33-.96-.99v-10.01c0-.66.32-.99.96-.99h1.04ZM21.64,87.74c.6,0,.95.29,1.06.87l1.93,7c.03.17.06.33.08.47.02.14.05.27.08.4.03.14.05.27.07.4h.05c.02-.13.04-.26.07-.4.03-.13.06-.26.08-.4.02-.14.06-.3.11-.47l2.02-7c.11-.56.47-.85,1.08-.85h.89c.58,0,.94.28,1.08.85l2,7c.05.17.08.33.11.47.02.14.05.27.08.4.03.14.05.27.07.4h.05c.02-.13.04-.26.07-.4.03-.13.06-.26.08-.4.02-.14.06-.3.11-.47l1.91-7c.14-.58.5-.87,1.08-.87h1.08c.36,0,.61.1.75.31.14.2.16.47.07.8l-3.08,10.05c-.16.55-.53.82-1.11.82h-1.58c-.6,0-.96-.28-1.11-.85l-1.81-5.99c-.05-.16-.09-.31-.12-.47s-.06-.3-.09-.42c-.03-.14-.05-.27-.07-.4h-.05c-.03.13-.06.26-.09.4-.03.13-.06.27-.09.42-.03.16-.07.31-.12.47l-1.81,5.99c-.14.56-.5.85-1.08.85h-1.62c-.56,0-.93-.27-1.08-.82l-3.11-10.05c-.09-.33-.07-.6.08-.8.15-.2.4-.31.74-.31h1.13Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_03_Symbol_Colour_Swish_Symbol",
    "data-name": "03_Symbol/Colour/Swish_Symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_Colour",
    "data-name": "Symbol/Colour"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-Swirl"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-Shape",
    className: "cls-3",
    d: "M21.08,70.52c14.89,7.12,33.27,3.6,44.37-9.63,13.16-15.68,11.12-39.06-4.57-52.21l-10.43,12.42c12.25,10.28,13.85,28.54,3.57,40.79-8.2,9.77-21.7,13.03-32.95,8.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Light-Cast",
    className: "cls-2",
    d: "M21.08,70.52c14.89,7.12,33.27,3.6,44.37-9.63,1.36-1.62,2.56-3.32,3.59-5.09,1.75-10.9-2.1-22.41-11.17-30.02-2.3-1.93-4.8-3.49-7.41-4.68,12.25,10.28,13.85,28.54,3.57,40.79-8.2,9.77-21.7,13.03-32.95,8.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left-Swirl"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-shape",
    className: "cls-4",
    d: "M53.05,3.61C38.16-3.51,19.78.01,8.67,13.24c-13.16,15.68-11.12,39.06,4.57,52.21l10.43-12.42c-12.25-10.28-13.85-28.54-3.57-40.79C28.3,2.47,41.79-.79,53.05,3.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    className: "cls-1",
    d: "M53.05,3.61C38.16-3.51,19.78.01,8.67,13.24c-1.36,1.62-2.56,3.32-3.59,5.09-1.75,10.9,2.1,22.41,11.17,30.02,2.3,1.93,4.8,3.49,7.41,4.68-12.25-10.28-13.85-28.54-3.57-40.79C28.3,2.47,41.79-.79,53.05,3.61"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwishLogoPrimary);
export default __webpack_public_path__ + "static/media/Swish_Logo_Primary.385f072d1e9e821362ec5e5a222f6fa1.svg";
export { ForwardRef as ReactComponent };